import React from 'react';

interface FeatureCard {
    icon: string;
    title: string;
    subtitle: string;
}

interface CardSectionProps {
    heading: string;
    cards: FeatureCard[];
}

const FeatureCardSection: React.FC<CardSectionProps> = ({ heading, cards }) => {
    return (
        <section className="py-12 px-6 max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-textColor mb-4">{heading}</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {cards.map((card, idx) => (
                    <div
                        key={idx}
                        className="bg-white rounded-xl shadow-md p-6 flex flex-col items-start gap-3"
                    >
                        <div className="w-12 h-12 bg-secondaryLight rounded-full flex items-center justify-center shadow text-2xl">
                            <img src={card.icon} alt="Icon" loading="lazy" />
                        </div>
                        <h3 className="text-lg font-bold text-textColor">{card.title}</h3>
                        <p className="text-sm text-gray-700">{card.subtitle}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default FeatureCardSection;
